// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3zvdD","content":"styles_content__3p26T","checkbox":"styles_checkbox__cyL18","checkboxLabel":"styles_checkboxLabel__3JxEm"};